import SmoothScroll from 'smooth-scroll'

/**
 * @author Dayne Coulson-Hoffacker
 */
export default class PageHero {
  /**
   * Constructs a PageHero component.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.ctaScroll = this.element.querySelector('[data-component="cta-scroll"]')
    this.scrollTarget = this.element.nextElementSibling
    this.scroll = new SmoothScroll()
    this.scrollOptions = {
      speed: 750,
      updateURL: false,
      header: '[data-component="global-header"]'
    }

    if (this.ctaScroll) {
      this.ctaScroll.addEventListener('click', () => {
        this.scroll.animateScroll(this.scrollTarget, this.element, this.scrollOptions)
      })
    }

  }
}



// WEBPACK FOOTER //
// ./components/section/page-hero/index.js